// Loan Plans related Redux Constants
export const [
  SET_LOAN_PLANS_DATA
] = [
  "SET_LOAN_PLANS_DATA"
];
